export default __webpack_public_path__ + "static/media/edit.73c6c4bf.svg";